import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Navbar } from './Navbar';
import { DrawerPanel } from './ui';
import { useCategories } from '../hooks/useCategories';
import { X, LayoutGrid, ChevronRight } from 'lucide-react';

export const FrontendLayout: React.FC = () => {
  const [catOpen, setCatOpen] = useState(false);
  const { categories: backendCats } = useCategories();
  const navigate = useNavigate();

  const handleCategorySelect = (name: string) => {
    navigate(`/catalogo?categoria=${encodeURIComponent(name)}`);
    setCatOpen(false);
  };

  return (
    <>
      <Navbar onOpenCategories={() => setCatOpen(true)} />
      <Outlet />

      {/* Category sidebar — global */}
      <DrawerPanel isOpen={catOpen} onClose={() => setCatOpen(false)} side="left">
        <div className="p-6 border-b border-slate-200 flex justify-between items-center bg-slate-50">
          <div className="flex items-center gap-2.5">
            <div className="bg-indigo-500/10 p-1.5 rounded-lg border border-indigo-500/20">
              <LayoutGrid className="w-4 h-4 text-indigo-600" />
            </div>
            <div>
              <h3 className="font-heading font-bold text-sm text-slate-900">Explorar Categorías</h3>
              <span className="text-[10px] text-slate-500 font-semibold uppercase tracking-wider block mt-0.5">
                Aye Otero Calzados
              </span>
            </div>
          </div>
          <button
            onClick={() => setCatOpen(false)}
            className="text-slate-500 hover:text-slate-900 p-1.5 hover:bg-slate-200/60 rounded-lg transition-colors"
            aria-label="Cerrar menú"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 p-5 overflow-y-auto space-y-4">
          <p className="text-[10px] text-slate-500 font-bold uppercase tracking-widest pl-1">Colecciones</p>
          <div className="space-y-2.5">
            {backendCats.map((cat) => {
              const Icon = cat.Icon;
              return (
                <button
                  key={cat.name}
                  onClick={() => handleCategorySelect(cat.name)}
                  className="w-full text-left p-4 rounded-xl transition-all duration-200 border bg-white border-slate-200/80 hover:border-indigo-500/30 hover:bg-indigo-500/5 flex items-center justify-between group active:scale-98 shadow-sm"
                >
                  <div className="flex items-center gap-3.5">
                    <div className="p-2.5 rounded-lg border bg-slate-50 border-slate-200 text-slate-500 group-hover:text-indigo-600 group-hover:border-indigo-500/20 group-hover:bg-indigo-500/10 transition-all">
                      <Icon className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="text-xs font-heading font-bold text-slate-800 group-hover:text-slate-950 transition-colors">
                        {cat.name}
                      </h4>
                      <p className="text-[10px] text-slate-500 group-hover:text-slate-600 transition-colors mt-0.5">
                        {cat.description}
                      </p>
                    </div>
                  </div>
                  <ChevronRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-indigo-600 group-hover:translate-x-0.5 transition-all" />
                </button>
              );
            })}
          </div>
        </div>
      </DrawerPanel>
    </>
  );
};
